import SOther from "./SOther_web"
export default SOther
